import type { PriceV1Hook } from './types/price.type';
import { BaseHookResult, createVersionedHook } from './utils/createVersionHooks';
import { usePriceV1 } from './v1';
import { usePriceV2 } from './v2/usePriceV2';

interface UsePrice extends PriceV1Hook, BaseHookResult {}

export const usePrice = createVersionedHook<UsePrice>(
  {
    v1: usePriceV1,
    v2: usePriceV2,
  },
  'usePrice',
);
